import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { object, string, array } from 'prop-types'
import Media from 'react-media'
import { JsonLd } from 'react-schemaorg'

// Import Components
import { AdsenseContext, Advertisement, ArticleSchema, ContentToolBar, DfpAdUnitSetup, Layout } from '@jelly/components'
import { ReviewBody } from './ReviewBody'

// Styled components via emotion
const ReviewContainer = styled.div`
	width: 100%;
	height: 100%;
`

Review.propTypes = {
	author: object.isRequired,
	breadcrumbs: object.isRequired,
	canonical: string.isRequired,
	category: object,
	channels: object.isRequired,
	docType: string.isRequired,
	guid: string.isRequired,
	lastModified: string.isRequired,
	meta: object.isRequired,
	pricing: object,
	published: string.isRequired,
	review: object.isRequired,
	relatedArticles: array,
	relatedBestPicks: array,
	structuredData: string,
	subtitle: string,
	thumbnail: object.isRequired,
	title: string,
	url: string,
}

/**
 * This the Review page's template wrapper
 */
export function Review({
	author,
	breadcrumbs,
	canonical,
	category, // category thumbnail for hero banner
	channels,
	docType,
	guid,
	lastModified,
	meta,
	pricing,
	published,
	relatedArticles,
	relatedBestPicks,
	review,
	structuredData,
	subtitle,
	thumbnail, //service logo
	title,
	url,
}) {
	const { adsenseMediaQuery, hasAdsense } = useContext(AdsenseContext)
	return (
		<ReviewContainer>
			<Layout inverseLinkColors={true} meta={meta} hasAdDisclosure={true}>
				{structuredData && <JsonLd item={structuredData} />}
				<JsonLd
					item={ArticleSchema({
						content: review.fullReview,
						author,
						canonical,
						breadcrumbs,
						lastModified,
						published,
						title,
						thumbnail,
					})}
				/>
				<ContentToolBar breadcrumbs={breadcrumbs} canonical={canonical} title={title} />
				<Advertisement />
				<ReviewBody
					{...{
						author,
						category,
						channels,
						lastModified,
						pricing,
						published,
						review,
						relatedBestPicks,
						relatedArticles,
						subtitle,
						thumbnail,
						title,
						url,
					}}
				/>
				{hasAdsense && (
					<Media query={adsenseMediaQuery} defaultMatches={false}>
						{(matches) => matches && <DfpAdUnitSetup channels={channels} docType={docType} guid={guid} />}
					</Media>
				)}
			</Layout>
		</ReviewContainer>
	)
}
